// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3vTfY","info":"Note_info__2gulP","note":"Note_note__1TWsX","actions":"Note_actions__HWwJs"};